<template>
  <div class="container">
    <div class="mt-5">
      <!-- <h2>{{ section.mean }}</h2> -->
      <Row v-for="row in section.rows" :key="row.row" :row="row"></Row>
    </div>
  </div>
</template>

<script>
import Row from './Row.vue'

export default {
  props: [
    'section',
  ],

  components: {
    Row,
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// RowList.vue?079b78bb